import { Button } from '../primitives/Button'
import styles from './Data.module.css'

export function Pagination({ page, pageCount, onPageChange, label = 'Pagination' }) {
  if (pageCount <= 1) return null
  return (
    <nav className={styles.pagination} aria-label={label}>
      <span className={styles.pageStatus}>Page {page} of {pageCount}</span>
      <div className={styles.pageActions}>
        <Button size="compact" variant="secondary" onClick={() => onPageChange(page - 1)} disabled={page <= 1} aria-label="Previous page">Previous</Button>
        <Button size="compact" variant="secondary" onClick={() => onPageChange(page + 1)} disabled={page >= pageCount} aria-label="Next page">Next</Button>
      </div>
    </nav>
  )
}
